import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';

interface IHubspotCompany {
  hubspotCompanyId: string;
  name: string;
  renewalDate: string;
}

export interface IHubspotCompanyParams {
  accountId: string;
}

export const COMPANY_THUNK_PREFIX = 'account/company';
export const fetchHubspotCompany: AsyncThunk<IHubspotCompany | void, IHubspotCompanyParams, ThunkAPI> =
  createAsyncThunk(
    COMPANY_THUNK_PREFIX,
    async (data, thunk) => {
      if (!isFeatureEnabled(Features.PlgExternal3)) {
        thunk.dispatch({
          type: 'DO_NOTHING'
        });
        return;
      }
      try {
        const response = await basicApiAsyncThunkCreator<IHubspotCompany | void, undefined>({
          endpoint: `accounts/crm/company/${data.accountId}`,
          microservice: SERVICES.USERS_SERVICE,
          authenticated: true,
          method: HttpMethods.Get,
          contentType: 'application/json'
        })(undefined, thunk);
        return response;
      } catch (err) {
        return thunk.rejectWithValue(err);
      }
    }
  );